import { create } from 'zustand'
import { apiPost } from '../compliance_api/restClient'

const LS_KEY = 'ai_comply_auth_v1'

type Stored = { token: string | null; refresh: string | null }

function load(): Stored {
  try {
    const raw = localStorage.getItem(LS_KEY)
    if (!raw) {
      const mainToken = localStorage.getItem('authToken')
      if (mainToken) return { token: mainToken, refresh: null }
      return { token: null, refresh: null }
    }
    const parsed = JSON.parse(raw)
    return { token: parsed.token || null, refresh: parsed.refresh || null }
  } catch {
    const mainToken = localStorage.getItem('authToken')
    if (mainToken) return { token: mainToken, refresh: null }
    return { token: null, refresh: null }
  }
}

function save(s: Stored) {
  localStorage.setItem(LS_KEY, JSON.stringify(s))
}

type AuthState = {
  token: string | null
  refresh: string | null
  login: (email: string, password: string) => Promise<void>
  refreshAccessToken: () => Promise<string | null>
  logout: () => void
}

const initial = load()

export const useAuthStore = create<AuthState>((set, get) => ({
  token: initial.token,
  refresh: initial.refresh,

  login: async (email, password) => {
    const data = await apiPost('/api/v1/auth/login/', { email, password })
    const next = { token: data.access, refresh: data.refresh }
    save(next)
    set(next)
  },

  refreshAccessToken: async () => {
    const r = get().refresh
    if (!r) return null
    try {
      const data = await apiPost('/api/v1/auth/refresh/', { refresh: r })
      const next = { token: data.access, refresh: data.refresh ?? r }
      save(next)
      set(next)
      return next.token
    } catch {
      get().logout()
      return null
    }
  },

  logout: () => {
    const next = { token: null, refresh: null }
    save(next)
    set(next)
  },
}))
